import styled from "styled-components"
export interface StyledMediaImgProps {
  aspect_ratio?: string
  mobile_aspect_ratio?: string
  mobile: boolean
  has_mobile_alt?: boolean
}
export interface StyledMediaVideoProps {
  mobile: boolean
  has_mobile_alt?: boolean
}

export const StyledIcon = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: absolute;
  padding: 32px;
  z-index: 1;
  cursor: pointer;
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    padding: 24px;
  }
  @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
    padding: 16px;
  }

  & img {
    max-width: 80px;
    max-height: 80px;
    object-fit: initial;
  }
  & p {
    text-transform: uppercase;
    border: 1px solid white;
    padding: 1.6rem 2.8rem;
    border-radius: 56px;
    min-height: 56px;
    text-align: center;
    color: ${(props) => props.theme.colors.white};
  }
`

export const StyledMedia = styled.div`
  display: flex;
  position: relative;
`
export const StyledMediaImg = styled.img<StyledMediaImgProps>`
  position: relative;
  width: 100%;
  object-fit: cover;
  border-radius: 30px;

  ${(props) =>
    props.mobile
      ? `
    @media (min-width: ${props.theme.breakPoints.tablet}) {
      display: none;
    }
    @media (max-width: ${props.theme.breakPoints.tablet}) {
      display: flex;
      aspect-ratio: ${
        props.mobile_aspect_ratio ? props.mobile_aspect_ratio : "initial"
      };
    }
  `
      : `
    @media (min-width: ${props.theme.breakPoints.tablet}) {
      display: flex;
      aspect-ratio: ${props.aspect_ratio ? props.aspect_ratio : "initial"};
    }
    @media (max-width: ${props.theme.breakPoints.tablet}) {
      display: ${props.has_mobile_alt ? "none" : "flex"};
    }
  `}
`
export const StyledMediaVideo = styled.video<StyledMediaVideoProps>`
  position: relative;
  width: 100%;
  object-fit: cover;

  ${(props) =>
    props.mobile
      ? `
    @media (min-width: ${props.theme.breakPoints.tablet}) {
      display: none;
    }
    @media (max-width: ${props.theme.breakPoints.tablet}) {
      display: flex;
    }
  `
      : `
    @media (min-width: ${props.theme.breakPoints.tablet}) {
      display: flex;
    }
    @media (max-width: ${props.theme.breakPoints.tablet}) {
      display: ${props.has_mobile_alt ? "none" : "flex"};
    }
  `}
`
export const StyledExternal = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  width: 100%;

  & iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

export const StyledButtonLabel = styled.div``
